import { faHome, faVolumeOff, faVolumeUp, faCircleQuestion, } from "@fortawesome/free-solid-svg-icons";
import { SceneStates } from "../datas/constants";
export function getParametersList(sceneState, withSound) {
    return [
        {
            id: "home",
            icon: faHome,
            tooltipKey: "home",
            clickFunctionKey: "goIntroScene",
            shouldShow: function () {
                return [SceneStates.CUVE_ALCOOL, SceneStates.CUVE_REACTEUR].includes(sceneState);
            },
        },
        {
            id: "parameters",
            icon: faCircleQuestion,
            tooltipKey: "parameters",
            clickFunctionKey: "showInstructions",
            shouldShow: function () {
                return [SceneStates.INTRO, SceneStates.CUVE_ALCOOL, SceneStates.CUVE_REACTEUR].includes(sceneState) &&
                    !window.matchMedia("(max-width: 768px)").matches;
            },
        },
        {
            id: "volume-off-icon",
            icon: faVolumeOff,
            tooltipKey: "volumeOff",
            clickFunctionKey: "disableSound",
            shouldShow: function () {
                return withSound &&
                    [SceneStates.INTRO, SceneStates.CUVE_ALCOOL, SceneStates.CUVE_REACTEUR].includes(sceneState);
            },
        },
        {
            id: "volume-up-icon",
            icon: faVolumeUp,
            tooltipKey: "volumeUp",
            clickFunctionKey: "enableSound",
            shouldShow: function () {
                return !withSound &&
                    [
                        SceneStates.INTRO,
                        SceneStates.CUVE_ALCOOL,
                        SceneStates.CUVE_REACTEUR
                    ].includes(sceneState);
            },
        },
    ];
}
